/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Analysis_In_ProgressInputs */

const en_case_detail_analysis_in_progress = /** @type {(inputs: Case_Detail_Analysis_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This case is currently under analysis. More information will be available soon.`)
};

const pt_br2_case_detail_analysis_in_progress = /** @type {(inputs: Case_Detail_Analysis_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este caso está em análise. Mais informações estarão disponíveis em breve.`)
};

/**
* | output |
* | --- |
* | "This case is currently under analysis. More information will be available soon." |
*
* @param {Case_Detail_Analysis_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_analysis_in_progress = /** @type {((inputs?: Case_Detail_Analysis_In_ProgressInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Analysis_In_ProgressInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_analysis_in_progress(inputs)
	return pt_br2_case_detail_analysis_in_progress(inputs)
});